var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-save",class:{ 'has-unsaved-changes': _vm.unsavedChangesPresent }},[_c('Save',{staticClass:"singularity-save__button"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }